export const MODERNIZATION_MIN_YEAR = 2020;
export const MODERNIZATION_MAX_YEAR = 2050;

export const RETROFITS_MIN_YEAR = 2020;
